<template>

  <Head :title="__('Login')" />

  <div class="min-h-screen flex flex-col lg:flex-row bg-white">
    <div class="relative hidden lg:flex lg:flex-1">
      <img :src="startSplash" alt="Login Splash" class="h-full w-full object-cover" />

      <div class="absolute top-6 left-8 flex items-center gap-3 text-white">
        <img :src="loginLogo" alt="Logo" class="h-12 w-auto" />
      </div>
    </div>

    <div class="flex flex-col w-full lg:w-[450px] bg-white min-h-screen lg:min-h-auto">
      <div class="flex lg:hidden items-center justify-center pt-8">
        <img :src="loginLogo" alt="Logo" class="h-10 w-auto" />
      </div>

      <div class="flex-1 flex items-center justify-center px-6 py-10 lg:px-8">
        <div class="w-full max-w-md">
          <div class="mb-8 text-center">
            <h1 class="text-2xl font-semibold text-gray-900">{{ __('Welcome') }}</h1>
            <p class="mt-2 text-sm text-gray-500">{{ __('Enter your email address and password below to log in') }}</p>
          </div>

          <v-form name="formLogin" class="space-y-5" @keyup.enter="login">
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1">{{ __('E-Mail Address') }}</label>
              <InputText id="email" type="text" size="small"
                class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50"
                :class="{ 'border-gray-300': !form.errors.email, 'border-red-400': form.errors.email }"
                v-model="form.email" @input="form.errors.email = null" />
              <div v-if="form.errors.email" class="mt-1 text-xs text-red-500">
                {{ __(form.errors.email) }}
              </div>
              <div v-if="form.errors.timesToLock" class="mt-1 text-xs text-red-500">
                {{ __(form.errors.timesToLock) }}
              </div>
            </div>

            <div>
              <label for="password" class="block text-sm font-medium text-gray-700 mb-1">{{ __('Password') }}</label>
              <InputText id="password" type="password" size="small"
                class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50"
                :class="{ 'border-gray-300': !form.errors.password, 'border-red-400': form.errors.password }"
                v-model="form.password" @input="form.errors.password = null" />
              <div v-if="form.errors.password" class="mt-1 text-xs text-red-500">
                {{ __(form.errors.password) }}
              </div>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <Checkbox inputId="remember" v-model="form.remember" binary />
                <label for="remember" class="ml-2 text-gray-600 text-sm">{{ __('Remember Me') }}</label>
              </div>
            </div>
            <div class="flex items-center">
              <Checkbox inputId="removeSession" v-model="form.removeSession" binary />
              <label for="removeSession" class="ml-2 text-gray-600 text-sm">{{ __('Remove session data') }}</label>
            </div>

            <div class="flex flex-col gap-2 mt-4">
              <Button @click="login" :label="__('Login')" :pt="{ icon: { class: 'mr-2 inline-block' } }"
                icon="pi pi-sign-in"
                class="w-full justify-center rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-white hover:bg-secondary-700 transition-colors" />
              <Button v-if="isLoginViaGithub" @click="githubLogin" label="Github" icon="pi pi-github"
                class="w-full justify-center rounded-md bg-gray-800 px-4 py-2 text-sm font-medium text-white hover:bg-gray-900 transition-colors" />
              <Button v-if="isLoginViaAzure" @click="azureLogin" label="Azure" icon="pi pi-microsoft"
                class="w-full justify-center rounded-md bg-yellow-500 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-600 transition-colors" />
            </div>

            <div v-if="errorGa2FaLogin" class="mt-2 text-center text-sm font-semibold text-red-500">
              {{ __('Invalid code specified in the second security level') }}
            </div>
            <div v-if="errorAzure" class="mt-2 text-center text-sm font-semibold text-red-500">
              {{ errorAzure }}
            </div>

            <div class="mt-4 flex items-center justify-center">
              <Link v-if="route().has('password-forget')" :href="route('password-forget')"
                class="inline-flex items-center gap-2 text-black-600 hover:text-black-700 hover:underline text-sm">
                <i class="pi pi-star text-black-400 text-xs"></i>
                <span>{{ __('Forgot Your Password?') }}</span>
              </Link>
            </div>
          </v-form>
        </div>
      </div>

      <footer class="px-4 py-4 text-sm text-gray-500">
        <div class="text-center">
          <p class="font-light">Powered by © 4Evolve wersja 1.0</p>
          <p class="text-xs text-gray-400 mt-1">rewizja {{ systemRevision }}</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<!--
<template>

    <Head :title="__('Login')" />
    <div class="min-h-screen w-full bg-splash-bg">
        <div class="flex items-center justify-center min-h-screen"
             style="opacity:1;">
            <div class="flex items-center justify-center min-h-screen">
                <div class="w-full max-w-md border border-gray-100 rounded-md shadow-2xl p-8 mx-4"
                     style="">
                    <div class="flex flex-col items-center mb-6">
                        <Image :src="loginLogo"
                               class="" />
                        <div class="text-2xl font-light text-gray-700">{{ __('Login') }}</div>
                    </div>
                    <v-form name="formLogin"
                            class="space-y-6"
                            @keyup.enter="login">
                        <div>
                            <label for="email"
                                   class="block text-gray-600 mb-1">{{ __('E-Mail Address') }}</label>
                            <InputText type="text"
                                       id="email"
                                       size="small"
                                       style="width:100%"
                                       :class="{ 'border-black-500': !form.errors.email, 'border-red-400': form.errors.email }"
                                       class="rounded px-3 py-2 border focus:outline-none focus:ring-2 focus:ring-black-200 w-full"
                                       @input="form.errors.email = null"
                                       v-model="form.email" />
                            <div v-if="form.errors.email"
                                 class="text-red-500 text-sm mt-1">{{ __(form.errors.email) }}</div>
                            <div v-if="form.errors.timesToLock"
                                 class="text-red-500 text-sm mt-1">{{ __(form.errors.timesToLock) }}</div>
                        </div>
                        <div>
                            <label for="password"
                                   class="block text-gray-600 mb-1">{{ __('Password') }}</label>
                            <InputText type="password"
                                       id="password"
                                       size="small"
                                       style="width:100%"
                                       :class="{ 'border-black-500': !form.errors.password, 'border-red-400': form.errors.password }"
                                       class="rounded px-3 py-2 border focus:outline-none focus:ring-2 focus:ring-black-200 w-full"
                                       @input="form.errors.password = null"
                                       v-model="form.password" />
                            <div v-if="form.errors.password"
                                 class="text-red-500 text-sm mt-1">{{ __(form.errors.password) }}</div>
                        </div>
                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <Checkbox inputId="remember"
                                          v-model="form.remember"
                                          binary />
                                <label for="remember"
                                       class="ml-2 text-gray-600 text-sm">{{ __('Remember Me') }}</label>
                            </div>
                        </div>
                        <div class="flex items-center">
                            <Checkbox inputId="removeSession"
                                      v-model="form.removeSession"
                                      binary />
                            <label for="removeSession"
                                   class="ml-2 text-gray-600 text-sm">{{ __('Remove session data') }}</label>
                        </div>
                        <div class="flex flex-col gap-2 mt-4">
                            <Button @click="login"
                                    class="bg-black-600 text-white px-4 py-2 rounded hover:bg-black-700 transition w-full"
                                    label="Login"
                                    icon="pi pi-sign-in" />
                            <Button v-if="isLoginViaGithub"
                                    @click="githubLogin"
                                    class="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-900 transition w-full"
                                    label="Github"
                                    icon="pi pi-github" />
                            <Button v-if="isLoginViaAzure"
                                    @click="azureLogin"
                                    class="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 transition w-full"
                                    label="Azure"
                                    icon="pi pi-microsoft" />
                        </div>
                        <div v-if="errorGa2FaLogin"
                             class="text-center text-red-500 text-base font-semibold mt-2">
                            {{ __('Invalid code specified in the second security level') }}
                        </div>
                        <div v-if="errorAzure"
                             class="text-center text-red-500 text-base font-semibold mt-2">
                            {{ errorAzure }}
                        </div>
                        <div class="flex items-center justify-center mt-4">
                            <i class="pi pi-star text-black-400 mr-2"
                               style="font-size: 1rem;"></i>
                            <Link :href="route('password-forget')"
                                  class="text-black-600 hover:underline text-sm"
                                  v-if="route().has('password-forget')">
                            {{ __('Forgot Your Password?') }}
                            </Link>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
    </div>

    <footer class="w-full flex items-center justify-between bg-gray-50 border-t border-gray-200 py-3 px-6 text-sm fixed bottom-0 left-0 z-10">
        <div class="flex items-center space-x-4">
            <Image :src="developerLogo"
                   class="h-8 w-auto" />
            <div>
                <span class="text-gray-500 font-light">Powered by © 4Evolve wersja 1.0</span>
            </div>
        </div>
    </footer>

</template>
-->

<script setup>
import { useForm, usePage } from '@inertiajs/vue3';
import { Head } from '@inertiajs/vue3';
import { Link } from '@inertiajs/vue3';

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';

import Layout from '@layouts/LayoutNoMenuNoFooter.vue';
import Image from '@helper/Image.vue';
import { __, setStoreValue, getStoreValue, getSessionValue, setSessionValue, getFromRoute } from '@helper/utils.js';
import { loginLogo, startSplash } from '@helper/constants.js';

defineOptions({ layout: Layout });

const props = defineProps({
  errorGa2FaLogin: Boolean,
  errorAzure: String,
  isLoginViaAzure: Boolean,
  isLoginViaGithub: Boolean,
  errors: Object,
});

// const isLoginViaGithub = true
// const isLoginViaAzure = false

// -----------------------------------------------------

const page = usePage();
const form = useForm({ email: '', password: '', remember: false, removeSession: false });
const systemRevision = page.props.systemRevision;

// -----------------------------------------------------

setStoreValue('appCaption', page.props.appCaption);
setStoreValue('systemRevision', systemRevision);

const isReloaded = getSessionValue('reloaded');
if (!isReloaded) {
  setSessionValue('reloaded', true);
}

// -----------------------------------------------------

const login = () => {
  form.post(route('app-login'));
  setSessionValue('reloaded', false);
};

// -----------------------------------------------------

const azureLogin = () => {
  window.location.href = '/azure/login';
  setSessionValue('reloaded', false);
};

// -----------------------------------------------------

const githubLogin = () => {
  window.location.href = '/github/login';
  setSessionValue('reloaded', false);
};

// -----------------------------------------------------
</script>
